import CircularProgress from "@mui/material/CircularProgress";
import { useEffect } from "react";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import { useLocation } from 'react-router-dom';
export default function LinkClicked() {
  const location = useLocation();
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const userLinkId = searchParams.get('userLinkId');
    const campaignLinkId = searchParams.get('campaignLinkId');
    const nLinkstruct = searchParams.get('nLinkstruct');
    const tolinkmail = searchParams.get('tolinkmail');
    const userLinkToRedirect = searchParams.get('userLinkToRedirect');
    const statergyLink = searchParams.get('statergyLinkClick');
    axios
    .get(`${BaseUrl.baseurl}/trigger-link-click-email-lead?userId=${userLinkId}&campaignId=${campaignLinkId}&node=${nLinkstruct}&toEmail=${tolinkmail}&stratergy=${statergyLink}`)
    .then((res) => {
     
    })
    .catch((err) => console.log("Error"));
    setTimeout(()=>{
        window.location.href=userLinkToRedirect
    },1000)
  }, [location.search]);

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress
      size={60}
      style={{
        color: "#1C485F",
      }}
    />
    </div>
  );
}
